import { AbstractFlightPlan, FlightPlanCriteria } from '@/types/utm/flightPlan.types';

import { ACTIVATIONS_TAG } from './activation.api';
import { UTM_URL, utmApi } from './utm.api';

export const flightPlanApi = utmApi.injectEndpoints({
  endpoints: (builder) => ({
    getFlightPlans: builder.query<AbstractFlightPlan[], FlightPlanCriteria>({
      query: ({ sites, droneCodes, fromDate, toDate, alsoArchived }) => ({
        url: `${UTM_URL}/flight-plans`,
        params: {
          sites,
          droneCodes,
          fromDate,
          toDate,
          alsoArchived,
        },
      }),
    }),
    createFlightPlan: builder.mutation<AbstractFlightPlan, AbstractFlightPlan>({
      query: (flightplan) => ({
        url: `${UTM_URL}/flight-plans`,
        method: 'POST',
        body: flightplan,
      }),
      invalidatesTags: [ACTIVATIONS_TAG],
    }),
    updateFlightPlan: builder.mutation<AbstractFlightPlan, AbstractFlightPlan>({
      query: (flightPlan) => ({
        url: `${UTM_URL}/flight-plans/${flightPlan.id}`,
        method: 'PUT',
        body: flightPlan,
      }),
      invalidatesTags: [ACTIVATIONS_TAG],
    }),
    reroute: builder.mutation<void, { id: number; fatoStart?: string; fatoEnd?: string }>({
      query: ({ id, fatoStart, fatoEnd }) => ({
        url: `${UTM_URL}/flight-plans/${id}`,
        method: 'PUT',
        params: {
          fatoStart: fatoStart,
          fatoEnd: fatoEnd,
        },
      }),
    }),
    deleteFlightPlan: builder.mutation<void, number>({
      query: (id) => ({
        url: `${UTM_URL}/flight-plans/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetFlightPlansQuery,
  useCreateFlightPlanMutation,
  useDeleteFlightPlanMutation,
  useUpdateFlightPlanMutation,
} = flightPlanApi;
